export const scheduleList = state => {
  return state.scheduleList;
};

export const scheduleDetails = state => {
  return state.scheduleDetails;
};